import { isSSR } from '@wix/thunderbolt-commons'
import { withDependencies } from '@wix/thunderbolt-ioc'
import {
	BrowserWindowSymbol,
	StructureAPI,
	IStructureAPI,
	IAppDidMountHandler,
	BrowserWindow,
} from '@wix/thunderbolt-symbols'

export const TestApiAppDidMountHandler = withDependencies(
	[BrowserWindowSymbol, StructureAPI],
	(window: NonNullable<BrowserWindow>, structureAPI: IStructureAPI): IAppDidMountHandler => ({
		appDidMount: async () => {
			if (isSSR(window)) {
				return
			}

			if (!window.testApi) {
				// @ts-ignore
				window.testApi = {}
			}

			window.testApi.structureAPI = structureAPI
		},
	})
)
